import React, { useEffect, useState } from 'react';

function FootballGame({ score, updateScore, onBack }) {
  // توپ بین دو بازیکن حرکت کند
  const [ballPosition, setBallPosition] = useState('left'); // 'left' یا 'right'

  useEffect(() => {
    const interval = setInterval(() => {
      setBallPosition(pos => (pos === 'left' ? 'right' : 'left'));
    }, 1200); // هر 1.2 ثانیه جابه‌جا شود
    return () => clearInterval(interval);
  }, []);

  // موقعیت توپ بر اساس state
  const ballStyle = ballPosition === 'left'
    ? { position: 'absolute', left: 90, top: 95, fontSize: 32, transition: 'left 0.9s' }
    : { position: 'absolute', left: 270, top: 95, fontSize: 32, transition: 'left 0.9s' };

  return (
    <div className="football-game" style={{ textAlign: 'center', marginTop: 40 }}>
      <h2>Football Game</h2>
      <div style={{
        background: 'linear-gradient(180deg, #4caf50 85%, #fff 100%)',
        border: '4px solid #fff',
        borderRadius: 20,
        width: 400,
        height: 220,
        margin: '40px auto',
        position: 'relative',
        boxShadow: '0 4px 16px rgba(0,0,0,0.08)',
        overflow: 'hidden'
      }}>
        {/* Center Line */}
        <div style={{position: 'absolute', top: '50%', left: 0, width: '100%', height: 2, background: '#fff', transform: 'translateY(-50%)'}} />
        {/* Left Goal */}
        <div style={{position: 'absolute', left: -8, top: '40%', width: 16, height: '20%', border: '2px solid #fff', borderRadius: 4, background: '#e0e0e0'}} />
        {/* Right Goal */}
        <div style={{position: 'absolute', right: -8, top: '40%', width: 16, height: '20%', border: '2px solid #fff', borderRadius: 4, background: '#e0e0e0'}} />
        {/* Players & Ball */}
        <span role="img" aria-label="player1" style={{position: 'absolute', left: 40, top: 70, fontSize: 38}}>🧑‍🦱</span>
        <span role="img" aria-label="football" style={ballStyle}>⚽️</span>
        <span role="img" aria-label="player2" style={{position: 'absolute', right: 40, top: 70, fontSize: 38}}>🧑‍🦰</span>
      </div>
      <div style={{margin:'20px 0'}}>
        <span style={{fontWeight:'bold'}}>{score.teamA} : </span>
        <button onClick={() => updateScore('football', score.scoreA-1 >= 0 ? score.scoreA-1 : 0, score.scoreB)}>-</button>
        <span style={{margin:'0 10px'}}>{score.scoreA}</span>
        <button onClick={() => updateScore('football', score.scoreA+1, score.scoreB)}>+</button>
        <span style={{margin:'0 20px'}}>|</span>
        <span style={{fontWeight:'bold'}}>{score.teamB} : </span>
        <button onClick={() => updateScore('football', score.scoreA, score.scoreB-1 >= 0 ? score.scoreB-1 : 0)}>-</button>
        <span style={{margin:'0 10px'}}>{score.scoreB}</span>
        <button onClick={() => updateScore('football', score.scoreA, score.scoreB+1)}>+</button>
      </div>
      <button onClick={onBack}>Back</button>
    </div>
  );
}

export default FootballGame;
